import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { DynamicForm } from '@insurancemenu/imenu-components-lib';
import EmployeeFlowLayout from 'components/common/subscriber/EmployeeFlowLayout';
import { SubscriberRouteV2Id } from 'routes/routesConfigV2';
import { useIMQSubscriberProfilePageStore } from 'store/pages/subscriber/imq/imq-subscriber-profile/pageStore';

const PageContent: React.FC = observer(() => {
  const { getInitialData, isInitialLoading, flowDelegate, dynamicFormDelegate, isStepCompleted, returnBack } =
    useIMQSubscriberProfilePageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <EmployeeFlowLayout
      contentWidth="standard"
      flowDelegate={flowDelegate}
      pageId={SubscriberRouteV2Id.SUBSCRIBER_IMQ_SUBSCRIBER_PROFILE}
      isInitialLoading={isInitialLoading}
      pageFooter={null}
    >
      <DynamicForm
        formDelegate={dynamicFormDelegate}
        onBack={returnBack}
        completeButtonText={isStepCompleted ? 'Update' : 'Complete'}
      />
    </EmployeeFlowLayout>
  );
});

export default PageContent;
